export default interface CompanyPaymentDto {
    userCount: number;
    licensesPaid: number;
    plan: Plan;
    addons: Addon[];
    smellScore: number;
    warningLevel: WarningLevel;
    warnBeforePaymentExpiry: number;
    paidFrom: number | null;
    paidTo: number | null;
    trialUntil?: number | null;
    trialExpired: boolean;
    trialGracePeriodUntil: number | null;
    freeLimit: number;
    nonProfit: boolean;
    paymentGracePeriodUntil: number | null;
    mutedUntil: number | null;
    privateNotes?: string;
    trialStarted: number | null;
    licenseCountExceeded: boolean;
    autoAdjustLicenses: boolean;
    overageLockout: boolean;
    requiredLicenseCount: number;
    freeUntil?: number | null;
}

export enum Plan {
    None,
    Bronze,
    Silver,
    Gold,
    Unified,
    'Performance Starter Pack',
    'Feedback and Performance Suite',
    'Feedback, Performance and Engagement Suite',
    Launch,
    Grow,
    Elevate,
    Free,
}

export enum WarningLevel {
    Active = 0,
    Locked = 10,
    Moved = 11,
    Maintenance = 12,
}

export type Addon = 'Engagement and Retention Analytics';
